import { Link } from "react-router-dom";

/** عنوان ردیف home — همان استایل بلوک‌های Tag قدیم */
export default function HomeRowTitle({
	title,
	allHref,
	className = "mb-4",
}) {
	return (
		<div
			className={[
				"flex items-center justify-between gap-3",
				className,
			].join(" ")}
		>
			<h2 className="font-Vazir-800 text-[18px] text-midGray transition-colors md:text-[20px]">
				{title}
			</h2>
			{allHref && (
				<Link
					to={allHref}
					className="shrink-0 font-Vazir-600 text-[13px] text-darkBlue hover:underline"
				>
					همه
				</Link>
			)}
		</div>
	);
}

export function homeCarouselAllHref(cards) {
	if (!cards?.length) return null;
	const kinds = new Set(cards.map((c) => c.kind));
	if (kinds.size !== 1) return null;
	const kind = kinds.values().next().value;
	if (kind === "workshop") return "/workshop_list/";
	if (kind === "webinar") return "/webinar_list/";
	if (kind === "video_clip") return "/video_clips/";
	if (kind === "doctor") return "/doctor_list/";
	return null;
}

export function cardToWebinarShape(card) {
	const idMatch = card.href?.match(/\/(\d+)\/?$/);
	return {
		id: idMatch ? Number(idMatch[1]) : card.href,
		title: card.title,
		image_url: card.image_url,
		instructors_detail: card.instructors_detail,
		j_create_date: card.j_create_date,
		price: card.price,
	};
}
